import * as React from "react";
import { Box, Button, Typography, Modal, FormHelperText } from "@mui/material";
import { createHostingLevelTag, createnewPermision } from "../../DAL/create";
import { updatePermision } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

export default function AssignHostingLevel({
  open,
  setOpen,
  Modeltype,
  Modeldata,
}) {
  const [rid, setRid] = React.useState(Modeldata?.userCode || "");
  const [hostLevel, setHostLevel] = React.useState(
    Modeldata?.hostLevelId || ""
  );
  const [error, setError] = React.useState(false);

  const isFormValid = rid?.trim() && hostLevel?.trim();

  React.useEffect(() => {
    setRid(Modeldata?.userCode || "");
    setHostLevel(Modeldata?.hostLevelId || "");
  }, [Modeldata]);

  const handleClose = () => {
    setOpen(false);
    setRid("");
    setHostLevel("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rid || !hostLevel) {
      setError(true);
      return;
    }

    try {
      if (Modeltype === "Add") {
        const response = await createHostingLevelTag({
          rid: rid,
          hostLevel: hostLevel,
        });
        if (response?.data?.statusCode == 201) {
          setOpen(false);
          enqueueSnackbar(response?.data?.message, { variant: "success" });
        } else {
          enqueueSnackbar(response?.message || "Something went wrong", {
            variant: "error",
          });
        }
      } else {
        const response = await updatePermision(Modeldata?.id, {
          rid: rid,
          hostLevel: hostLevel,
        });
        if (response?.data?.statusCode == 200) {
          setOpen(false);
          enqueueSnackbar(response?.data?.message, { variant: "success" });
        } else {
          enqueueSnackbar(response?.message || "Something went wrong", {
            variant: "error",
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      enqueueSnackbar("Error submitting form", { variant: "error" });
    }
  };

  return (
    <Box sx={style}>
      <Typography id="modal-title" variant="h6" component="h2">
        {Modeltype} Assign Hosting Level
      </Typography>

      <Box sx={{ marginTop: "15px" }}>
        <Typography>User RID *</Typography>
        <input
          type="text"
          value={rid}
          onChange={(e) => setRid(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginTop: "5px",
          }}
        />
        {error && !rid && (
          <FormHelperText sx={{ color: "red" }}>RID is required</FormHelperText>
        )}
      </Box>

      <Box sx={{ marginTop: "15px" }}>
        <Typography>Host Level *</Typography>
        <input
          type="text"
          value={hostLevel}
          onChange={(e) => setHostLevel(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginTop: "5px",
          }}
        />
        {error && !hostLevel && (
          <FormHelperText sx={{ color: "red" }}>
            Host level is required
          </FormHelperText>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <Button
          type="button"
          variant="contained"
          sx={{ backgroundColor: "#B1B1B1", textTransform: "none" }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          type="submit"
          variant="contained"
          className={isFormValid ? "gradientButton" : ""}
          sx={{ textTransform: "none" }}
          disabled={!isFormValid}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}
